import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { useQueryClient } from 'react-query';
import { Field, FieldInputProps, Formik } from 'formik';
import { useNavigate } from 'react-router-dom';

import { Logo } from 'theSource/components/Logo';
// Styling must match login page
import {
  BackgroundImageContainerStyled,
  LoginPageWrapperStyled,
  LogoWrapperStyled,
  PaperStyled,
} from '../Login/LoginStyled';
import {
  GET_COMPANY_MANIFEST_QUERY_KEY,
} from 'theSource/queries';
import { MFAFormValues } from './types';
import { CompanyManifestResponseDto } from 'theSource/queries/useCompanyManifestQuery/types';
import { ROUTES } from 'theSource/app/routes';
import { PsButtonTuner, PsCheckboxTuner, PsTextTuner } from 'stencilSetup';

export const MFA = () => {
    //TODO: The v1/Login endpoint needs to return some kind of information to state an MFA is required and the type of MFA (email and text supported in this UI). same with native auth
    //TODO: when the login endpoint returns that MFA is required, the UI should navigate to the MFA page if not, any attempt to access the /mfa page should redirect to the login page
    //TODO: an api call needs to be made on the submit to validate that the code entered is correct (if not display error message) and complete the login process
  const queryClient = useQueryClient();
  const manifestData: CompanyManifestResponseDto = queryClient.getQueryData(
    GET_COMPANY_MANIFEST_QUERY_KEY
  )!;
  const navigate = useNavigate();
  const { t } = useTranslation('pages.login');

  const INITIAL_VALUES: MFAFormValues = {
    mfacode: undefined,
    rememberDevice: true,
  };

  const validationSchema: yup.SchemaOf<MFAFormValues> = 
      yup.object({
        mfacode: yup.string().required(),
        rememberDevice: yup.boolean().required(),
      });

  const handleResend = () => {
    navigate(ROUTES.public.login.path);
  };


  const handleSubmit = (values: MFAFormValues) => {
    //TODO: api needed to submit the MFA code { setSubmitting }: FormikHelpers<MFAFormValues> may be needed above to handle submit state
    console.log('here',values); //this log is intentional as this page is currently UI only
  };

  return (
    <LoginPageWrapperStyled data-testid="mfa-page">
      <BackgroundImageContainerStyled
        data-testid="background-image"
        src={manifestData.background_image}
      />
      <PaperStyled>
        <div className="pt-5">
          <LogoWrapperStyled>
            <Logo/>
          </LogoWrapperStyled>
        </div>
        <h3 className="mt-5">{t('mfaPages.twoStepVerificationText')}</h3>
        <p>{t('mfaPages.singlePhoneNumberText')}</p> 
        <Formik
          initialValues={INITIAL_VALUES}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, dirty, handleChange, handleBlur, isValid, handleSubmit }) => (
            <Box
              data-testid='mfa-form'
              component="form"
              onSubmit={handleSubmit}
            >
            <Field name="mfacode">
              {(props: { field: FieldInputProps<string> }) => (
                <PsTextTuner
                  inputId="mfacode"
                  type="text"
                  name={props.field.name}
                  label={t('mfaPages.enterCodeText')}
                  required={true}
                  onInput={handleChange}
                  onBlur={handleBlur}
                  value={values.mfacode}
                />
              )}
            </Field>
            <Field name="rememberDevice">
              {(props: { field: FieldInputProps<boolean> }) => (
                <PsCheckboxTuner
                  data-testid="remember-device-checkbox"
                  inputId="remember-device-checkbox"
                  name={props.field.name}
                  label={t('mfaPages.rememberDeviceText', { days: 90})}
                  onInput={handleChange}
                  onBlur={handleBlur}
                  checked={values.rememberDevice}
                  extraClass="mb-3"
                />
              )}
            </Field>
              <PsButtonTuner
                buttonId="save-button"
                label={t('loginButtonTitle')}
                level="primary"
                type="submit"
                disabled={!dirty || !isValid} //TODO: can add isSubmitting to disable button while submitting form 
                extraClass="btn-block"
                rootClass='hydrated btn-block'
              />
            </Box>
          )}
        </Formik>
        <p className="mt-4">{t('mfaPages.notReceivedCode')}
          <ps-button
            level="tertiary"
            id="resend-mfa-link"
            label={t('mfaPages.resendAgain')}
            show-underline
            data-testid="resend-mfa-link"
            onClick={handleResend}
            extraClass="pl-1"
          />
        </p>
      </PaperStyled>
    </LoginPageWrapperStyled>
  );
};
